import { useReducer } from "react";
import { LIVE_FEED } from "../../constants";
import { LiveFeedContext, LiveFeedDispatchContext } from "./LiveFeedContext";
import {
  getByFieldValue,
  isEmptyList,
  isNullOrUndefined,
  sortByDateField,
} from "../../utils";

export const initialState = {
  liveFeedItems: [],
  lastUpdatedAt: null,
};

export function liveFeedReducer(state, action) {
  switch (action.type) {
    case "addLiveFeedItems":
      const itemsToAdd = [];
      if (!isEmptyList(action.value)) {
        for (let i = 0; i < action.value.length; i++) {
          const itemToCheck = action.value[i];
          const existingItem = getByFieldValue(
            state.liveFeedItems,
            "uuid",
            itemToCheck.uuid
          );
          if (isNullOrUndefined(existingItem)) {
            itemsToAdd.push(itemToCheck);
          }
        }
      }
      const liveFeedItemsToUpdate = [...itemsToAdd, ...state.liveFeedItems];
      if (liveFeedItemsToUpdate.length > LIVE_FEED.MAX_ITEMS) {
        liveFeedItemsToUpdate.splice(LIVE_FEED.MAX_ITEMS);
      }
      sortByDateField(liveFeedItemsToUpdate, "submittedAt", true);
      return {
        ...state,
        liveFeedItems: liveFeedItemsToUpdate,
        lastUpdatedAt: new Date(),
      };

    default:
      console.log(`Unknown action: ${action.type}`);
      return {
        ...state,
      };
  }
}

export default function LiveFeedProvider({ children }) {
  const [main, dispatch] = useReducer(liveFeedReducer, initialState);
  return (
    <LiveFeedContext.Provider value={main}>
      <LiveFeedDispatchContext.Provider value={dispatch}>
        {children}
      </LiveFeedDispatchContext.Provider>
    </LiveFeedContext.Provider>
  );
}
